import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

interface Props {
  title: string;
  value: string | number;
  icon: React.ElementType;
  color: string;
  trend?: { value: number; positive: boolean };
  loading?: boolean;
}

const StatsCard: React.FC<Props> = ({ title, value, icon: Icon, color, trend, loading = false }) => {
  if (loading) {
    return (
      <div className="rounded-lg border border-surface-200 bg-white p-5 shadow-sm">
        <div className="animate-pulse space-y-3">
          <div className="flex items-center justify-between">
            <div className="h-4 w-24 rounded bg-surface-200" />
            <div className="h-10 w-10 rounded-full bg-surface-200" />
          </div>
          <div className="h-8 w-20 rounded bg-surface-200" />
          <div className="h-3 w-16 rounded bg-surface-200" />
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-lg border border-surface-200 bg-white p-5 shadow-sm transition-shadow hover:shadow-md">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-surface-500">{title}</span>
        <div
          className="flex h-10 w-10 items-center justify-center rounded-full"
          style={{ backgroundColor: `${color}15` }}
        >
          <Icon className="h-5 w-5" style={{ color }} aria-hidden="true" />
        </div>
      </div>
      <p className="mt-2 text-3xl font-bold text-surface-900">{value}</p>
      {trend && (
        <div className="mt-1 flex items-center gap-1 text-sm">
          {trend.positive ? (
            <TrendingUp className="h-4 w-4 text-success-500" />
          ) : (
            <TrendingDown className="h-4 w-4 text-danger-500" />
          )}
          <span className={trend.positive ? 'text-success-600' : 'text-danger-600'}>
            {trend.value}%
          </span>
          <span className="text-surface-400">vs mes anterior</span>
        </div>
      )}
    </div>
  );
};

export default StatsCard;
